import { TransferTypeTyping } from 'store/ducks/statements/types';
import BanksData from 'static/banks.json';
import dayjs from 'dayjs';

export const getFormattedTransferType = (transferType: TransferTypeTyping) => {
  const transferTypes = {
    PIX: 'Pix',
    SPB: 'TED',
    INT: 'Same institution',
  };

  return transferTypes[transferType];
};

export const formatUserDocument = (document: string) =>
  `***.${document.substring(0, 3)}.${document.substring(2, 5)}-**`;

export const getBankName = (bankCompe: string) =>
  BanksData.find((bank) => bank.compe_code === parseInt(bankCompe))
    ?.long_name || 'Bank not found';

export const formatDateTime = (date: string) => {
  const momentDate = dayjs(date);
  const dateFormatted = momentDate.format('DD/MM/YY');
  const timeFormatted = momentDate.format('HH:mm:ss');
  return { dateFormatted, timeFormatted };
};
